// Spanish translations
const es = {
    // App Header
    appTitle: "Motor de Optimización de Precios con IA",

    // Language selector
    language: "Idioma",
    english: "Inglés",
    spanish: "Español",

    // Sidebar Menu
    menu: {
        // Plataforma nueva (src/nueva)
        noDictionary: "No hay diccionario configurado",
        home: "Inicio",
        mediaMonitoring: "Monitoreo de Medios",
        priceMonitor: "Monitor de Precios",
        priceAlerts: "Alertas de Precios",
        opportunities: "Oportunidades Comerciales",
        chat: "Conversaciones",
        aiAssistant: "Asistente IA",
        newChat: "Nueva consulta",
        reports: "Reportes",
        analytics: "Análisis",
        admin: "Admin",
        administration: "Panel de Administración",
        settings: "Configuración",
        help: "Ayuda",
        faq: "Preguntas Frecuentes",
        guide: "Consultas sugeridas",
        contact: "Contacto",
        terms: "Términos y Condiciones",
        logout: "Cerrar Sesión",
        moduleDisabled: "Este módulo no está disponible para tu cuenta",
        recentChats: "Chats Recientes",
        noChats: "No hay conversaciones",
        savedQueries: "Consultas Guardadas",
        noSavedQueries: "No hay consultas guardadas",
        customReports: "Reportes Personalizados",
        newReport: "Nuevo reporte",
        noReports: "Sin reportes aún",
        deleteReport: "¿Deseas eliminar este reporte?",
        dataDictionary: "Diccionario de Datos",
        uploadedFiles: "Archivos Subidos",
        uploadFile: "Subir Archivo",
        noFiles: "No hay archivos subidos",
        confirmDelete: "Confirmar eliminación",
        deleteConversation: "¿Deseas eliminar esta conversación?",
        deleteSavedQuery: "¿Deseas eliminar esta consulta guardada?",
        agentMemory: "Memoria del Agente",
        agentMemoryTitle: "Instrucciones Personalizadas",
        agentMemoryDescription: "Escribe instrucciones que el agente recordará en todas tus conversaciones. Por ejemplo: preferencias, contexto de tu negocio, formato de respuestas, etc.",
        agentMemoryPlaceholder: "Ejemplo:\n- Siempre responde en español\n- Trabajo en el sector farmacéutico\n- Prefiero ver precios en MXN\n- Mis principales competidores son: Walmart, Soriana, Chedraui",
        agentMemoryTip: "También puedes usar '/recuerda' en el chat para que el agente agregue información automáticamente.",
        goToAdmin: "Ir al Panel de Administración",
        interactiveGuide: "Guía Interactiva",
        editTitle: "Editar título"
    },

    // Homepage - Media Monitoring
    homepage: {
        title: "Monitoreo de Medios",
        subtitle: "Configura tus keywords para monitorear noticias relevantes",
        configureKeywords: "Configurar Keywords",
        update: "Actualizar",
        searching: "Buscando...",
        customize: "Personalizar",
        country: "País de las noticias",
        countryHint: "Cambia el país de búsqueda. Las noticias se recargarán automáticamente.",

        // Tabs
        tabNews: "Noticias",
        tabSaved: "Destacadas",
        savedTitle: "Noticias Destacadas",

        // TikTok
        tiktokTitle: "Posts de TikTok",
        tiktokRefresh: "Actualizar TikTok",
        tiktokSearching: "Buscando...",
        tiktokPendingTitle: "Buscando posts en TikTok…",
        tiktokPendingHint: "Esto puede tardar 3-8 minutos. Puedes navegar a otra pestaña mientras tanto.",
        tiktokStartedAt: "Iniciado el",
        tiktokLastFetched: "Última actualización:",
        tiktokEmpty: "Sin posts todavía. Presiona Actualizar para iniciar la búsqueda.",
        tiktokEmptyNoKeywords: "Agrega keywords primero — TikTok usa las mismas keywords de noticias.",
        savedTiktoksHeader: "TikToks destacados",
        tiktokSortLabel: "Ordenar por",
        tiktokSortViews: "Más vistos",
        tiktokSortRecent: "Más recientes",
        tiktokSortOldest: "Más antiguos",
        tiktokSortLikes: "Más likes",
        tiktokSortComments: "Más comentarios",
        // Texto relativo de edad de post
        agoPrefix: "Hace",
        monthAgo: "mes",
        monthsAgo: "meses",
        yearAgo: "año",
        yearsAgo: "años",

        // Modal de comentarios
        commentsTitle: "Comentarios",
        commentsClose: "Cerrar",
        commentsViewOnTiktok: "Ver en TikTok",
        commentsLoadButton: "Cargar comentarios",
        commentsConfirmCount: "Este post tiene {count} comentarios.",
        commentsCap: "Guardaremos hasta {cap} comentarios (top por likes).",
        commentsCapExceeded: "El post excede {cap}. Guardaremos solo los top {cap} por likes.",
        commentsPending: "Buscando comentarios... Puede tardar 3-8 minutos.",
        commentsRetry: "Reintentar",
        commentsErrorGeneric: "No se pudieron cargar los comentarios.",
        commentsErrorNetwork: "Error de red al cargar comentarios.",
        commentsEmpty: "Sin comentarios disponibles.",
        commentsLoadedMeta: "{count} comentarios cargados · {when}",
        commentsViewThread: "Ver {count} respuestas en TikTok",

        // Análisis de sentimientos
        sentimentTitle: "Análisis de sentimientos",
        sentimentCta: "Analizar sentimientos",
        sentimentAnalyzing: "Analizando...",
        sentimentReanalyze: "Re-analizar",
        sentimentThemes: "Temas principales",
        sentimentTopPositive: "Top positivo",
        sentimentTopNegative: "Top crítico",
        sentimentErrorGeneric: "No se pudo completar el análisis.",
        sentimentErrorNetwork: "Error de red al analizar comentarios.",

        // Keywords panel
        keywordsConfig: "Configuración de Keywords",
        keywordsConfigDesc: "Define las palabras clave para monitorear noticias",
        searchPlaceholder: "Escribe una keyword y presiona Enter...",
        useIndustryTemplate: "Usar plantilla por industria",
        activeKeywords: "Keywords Activas",
        resetDefault: "Por defecto",
        clearAll: "Limpiar",
        loadingKeywords: "Cargando keywords...",
        noKeywordsConfigured: "No hay keywords configuradas.",
        addKeywordsHint: "Agrega keywords manualmente o usa una plantilla.",
        lastSaved: "Último guardado:",
        saveConfig: "Guardar Configuración",
        saving: "Guardando...",
        keywordsLimitError: "No es posible agregar más de 20 keywords",
        keywordsLimitReached: "Límite de 20 keywords alcanzado",
        confirmRestoreDefaults: "¿Restaurar las keywords por defecto de la organización?",

        // Status bar
        news: "noticias",

        // News section
        relevantNews: "Noticias Relevantes",
        readArticle: "Leer artículo",
        noLink: "Sin enlace",
        today: "Hoy",
        yesterday: "Ayer",
        daysAgo: "días",

        // Loading & empty states
        searchingNews: "Buscando noticias...",
        analyzingKeywords: "Analizando {count} keywords",
        searchMayTake: "Esto puede tardar 30-45 segundos",
        noNewsFound: "No se encontraron noticias",
        tryOtherKeywords: "Intenta con otras keywords o actualiza más tarde",
        searchNews: "Buscar noticias",

        // Presets
        presetsPharmaceutical: "Farmacéutica",
        presetsRetail: "Retail",
        presetsTechnology: "Tecnología",
        presetsFinance: "Finanzas"
    },

    // Alerts Page - Price Monitor
    alerts: {
        title: "Monitor de Precios",
        subtitle: "Alertas de cambio de precio en competidores",
        update: "Actualizar",
        info: "Información",

        // Config panel
        minThreshold: "Variación mínima absoluta (%)",
        maxThreshold: "Variación máxima absoluta (%)",
        productsPerChain: "Productos por cadena",
        filterByUpcs: "Filtrar por UPCs",
        enabled: "Activado",
        disabled: "Desactivado",
        apply: "Aplicar",
        upcs: "UPCs",

        // Summary
        alerts: "alertas",
        changeGte: "cambio",
        upcFilterActive: "Filtro UPCs activo",
        filterChannels: "Filtrar canales",

        // Product card
        previous: "Anterior:",
        current: "Actual:",
        viewHistory: "Ver historial",
        viewInStore: "Ver en tienda",

        // History modal
        priceHistory: "Historial de Precios",
        priceEvolution: "Evolución del precio",
        lastRecords: "Últimos {count} registros",
        date: "Fecha",
        regularPrice: "Precio Regular",
        salePrice: "Precio Oferta",
        finalPrice: "Precio Final",
        currentPrice: "Precio actual",
        detectedChange: "Cambio detectado",

        // UPC Manager
        manageTrackedUpcs: "Gestionar UPCs Monitoreados",
        fileExists: "Archivo existe con {count} UPCs",
        noTrackingFile: "No hay UPCs configurados. Agrega UPCs para comenzar a monitorear.",
        currentUpcs: "UPCs actuales",
        clear: "Limpiar",
        more: "más",
        loadFromFile: "Cargar desde archivo",
        downloadTemplate: "Descargar plantilla CSV",
        uploadFile: "Subir archivo CSV",
        orEnterManually: "O ingresa manualmente",
        upcsHint: "UPCs separados por coma o uno por línea. Al guardar se actualizará el archivo en S3.",
        cancel: "Cancelar",
        replaceAll: "Reemplazar todo",
        addUpcs: "Agregar UPCs",
        save: "Guardar",
        upcsStorageInfo: "Los UPCs guardados se usarán para filtrar las alertas de precio. El umbral aplica como variación absoluta (± %).",

        // States
        analyzingPriceChanges: "Analizando cambios de precio...",
        noPriceAlerts: "No hay alertas de precio",
        noChangesDetected: "No se detectaron cambios de precio con variación entre {min}% y {max}%",
        noChangesInTracked: "No se detectaron cambios de precio en tus {count} UPCs monitoreados",
        retry: "Reintentar",
        noHistoryAvailable: "No hay historial de precios disponible",
        lastRecordedDate: "Fecha no disponible",
        noUpcsConfigured: "No hay UPCs configurados",
        viewAllProducts: "Ver todos los productos",
        filterOnlyMyUpcs: "Filtrar solo mis UPCs",
        clearAllUpcs: "Eliminar todos los UPCs",
        replaceAllUpcs: "Reemplazar todos los UPCs existentes",

        // Info modal
        howToUse: "Cómo usar el Monitor de Precios",
        overviewTitle: "Vista general",
        overviewDesc: "Muestra los productos con mayor cambio de precio por cadena, útil para detectar movimientos significativos en el mercado.",
        filterByUpcsTitle: "Filtrar por UPCs",
        filterByUpcsDesc: "Activa el toggle 'Filtrar por UPCs' para ver solo los productos que has configurado. Para agregar UPCs:",
        filterStep1: "Haz clic en el botón 'UPCs'",
        filterStep2: "Descarga la plantilla CSV o sube tu archivo",
        filterStep3: "Los UPCs se guardan en tu carpeta",
        understood: "Entendido",

        // Sorting options
        sortBy: "Ordenar por",
        sortHighest: "Mayor variación",
        sortLowest: "Menor variación",
        sortPositive: "Solo aumentos",
        sortNegative: "Solo bajas",

        // Show all tracked UPCs
        showAllTracked: "Ver todos",
        showOnlyWithChanges: "Mostrar solo UPCs con cambios de precio",
        showAllTrackedUpcs: "Mostrar todos los UPCs prioritarios (con o sin cambio)",
        onlyChanges: "Con cambios",

        // Channels
        selectChannels: "Seleccionar canales",
        all: "Todos",
        none: "Ninguno",

        // Email notifications
        emailNotifications: "Notificaciones por email",
        emailNotificationsEnable: "Activar notificaciones por correo",
        emailNotificationsDisable: "Desactivar notificaciones por correo",

        // Umbral (rango de variación sobre valor absoluto)
        thresholdHint: "Variación mínima (%). Presiona Enter o sal del campo para aplicar.",
        minThresholdHint: "Variación mínima en % (valor absoluto). 0 incluye productos sin cambio. Enter o salir del campo para aplicar.",
        maxThresholdHint: "Variación máxima en % (valor absoluto), filtra outliers. Ej: máx 10 = solo lo que varió dentro de ±10%.",
        changeBetween: "variación absoluta entre {min}% y {max}%",

        // Base de variación (Precio Final vs Precio Regular / full price)
        priceBasisLabel: "Variación sobre",
        basisFinal: "Precio Final",
        basisFull: "Precio Regular",
        basisFinalHint: "Variación calculada sobre el precio final (con ofertas), usando el precio anterior precalculado.",
        basisFullHint: "Variación calculada sobre el precio regular (full price). El precio anterior se calcula al vuelo, puede tardar un poco más.",

        // Selector de vista
        viewMode: "Vista",
        viewGrid: "Tarjetas",
        viewTable: "Tabla",

        // Columnas de tabla
        colChain: "Cadena",
        colProduct: "Producto",
        colPrevious: "Anterior",
        colCurrent: "Actual",
        colVariation: "Variación",
        downloadExcel: "Descargar Excel",
        downloadExcelHint: "Descarga en Excel las alertas que estás viendo, con los filtros aplicados",
        excelSheetAlerts: "Alertas",
        excelSheetFilters: "Filtros",
        excelFilter: "Filtro",
        excelValue: "Valor",
        excelRange: "Rango de variación",
        excelBasis: "Base de precio",
        excelSort: "Orden",
        excelChains: "Cadenas",
        excelUpcFilter: "Filtro de UPCs",
        excelRows: "Alertas exportadas",
        excelDownloadedAt: "Fecha de descarga",
        excelYes: "Sí",
        excelNo: "No"
    },

    // Chat
    chat: {
        // Plataforma nueva (src/nueva)
        stop: "Detener",
        stopAnswer: "Detener respuesta",
        stopped: "Respuesta detenida",
        copyAnswer: "Copiar respuesta",
        copyCode: "Copiar código",
        codeLabel: "código",
        mode: "Modo de procesamiento",
        modeNormal: "Normal",
        modeMax: "Máximo",
        modeNormalDesc: "Procesamiento normal (Sonnet): rápido y eficiente",
        modeMaxDesc: "Procesamiento máximo (Opus): mayor calidad, más lento y costoso",
        attach: "Adjuntar archivo (imagen, Excel, CSV, PDF)",
        emptyTitle: "Asistente IA",
        emptyText: "Pregunta por tus precios, competidores, ventas o márgenes. Consulto tus datos, los grafico y puedes guardar las respuestas en un reporte.",
        historyError: "No pudimos cargar la conversación.",
        historyNotFound: "Esta conversación no existe o no es tuya.",
        retry: "Reintentar",
        title: "Asistente IA",
        placeholder: "Pregunta sobre tus datos · Escribe @ para archivos · /recuerda para entrenar al agente · /ticket para pedir un cambio a Data Bunker",
        send: "Enviar",
        thinking: "Pensando...",
        error: "Ocurrió un error. Por favor intenta de nuevo.",
        newConversation: "Nueva conversación",
        clearChat: "Limpiar chat",
        exportChat: "Exportar chat",
        disclaimer: "Aunque analizo datos rápidamente, la decisión final es tuya. Mis sugerencias son solo orientativas, revisa cuidadosamente antes de actuar.",

        // Suggested questions
        loadingSuggestions: "Generando sugerencias...",
        suggestedQuestions: [
            "¿Cuáles son los productos con mayores ventas en unidades del último mes?",
            "¿Qué categorías tienen los mejores márgenes de ganancia?",
            "¿Cómo se comparan nuestros precios con los del mercado por categoría?"
        ],

        // Data table
        rows: "filas",
        columns: "columnas",
        export: "Exportar",
        visualize: "Visualización avanzada",
        chartModalTitle: "Visualización de datos",
        viewData: "Ver Datos",
        downloadExcel: "Descargar Excel",
        downloadCSV: "Descargar CSV",
        downloadPDF: "Descargar PDF",
        loadingData: "Cargando datos...",
        options: "Opciones",
        saving: "Guardando...",
        saveQuery: "Guardar consulta",
        saveToReport: "Guardar en reporte",
        saveToReportTitle: "Guardar respuesta en reporte",
        saveChartToReportTitle: "Guardar gráfica en reporte",
        createNewReportWithMessage: "Crear nuevo reporte con esta respuesta",
        createNewReportWithChart: "Crear nuevo reporte con esta gráfica",
        orAddToExisting: "o añadir a uno existente:",
        loadingReports: "Cargando reportes…",
        noReportsYet: "No tienes reportes. Crea uno nuevo arriba.",
        blocksCount: "bloques",
        savedInReport: "Guardado en",
        view: "Ver",
        chart: "Gráfica",
        download: "Descargar",
        generateChart: "Generar gráfica",
        downloadTableAsExcel: "Descargar tabla como Excel",

        // Chart
        chartType: "Tipo de gráfico",
        bars: "Barras",
        lines: "Líneas",
        pie: "Circular",
        doughnut: "Dona",
        dataConfig: "Configuración de datos",
        xAxis: "Eje X (Categoría)",
        yAxis: "Eje Y (Valor)",
        aggregation: "Agregación",
        sum: "Suma",
        average: "Promedio",
        count: "Conteo",
        max: "Máximo",
        min: "Mínimo",
        dataLimit: "Límite de datos",
        allData: "Todos",
        categories: "categorías",
        records: "registros"
    },

    // Admin
    admin: {
        title: "Panel de Administración",
        back: "Volver",
        users: "Usuarios",
        files: "Archivos",
        guide: "Guía",
        plan: "Mi Plan",
        terms: "Términos",
        faq: "FAQ",
        plans: "Planes",

        // User manager
        usersTitle: "Usuarios de la Organización",
        configureMyMFA: "Configurar mi MFA",
        totalUsers: "Total Usuarios",
        active7Days: "Activos (7 días)",
        active30Days: "Activos (30 días)",
        administrators: "Administradores",
        searchUsers: "Buscar usuarios...",
        addUser: "Agregar Usuario",
        editUser: "Editar Usuario",
        deleteUser: "Eliminar Usuario",
        username: "Usuario",
        organization: "Organización",
        role: "Rol",
        lastAccess: "Último Acceso",
        pbiAccess: "Accesos PBI",
        messages: "Mensajes",
        registrationDate: "Registro",
        actions: "Acciones",
        loadingUsers: "Cargando usuarios...",
        noUsersInOrg: "No hay usuarios en esta organización",
        never: "Nunca",
        justNow: "Hace un momento",
        minutesAgo: "min",
        hoursAgo: "h",
        yesterday: "Ayer",
        daysAgo: "días",
        weeksAgo: "semanas",

        // Plan manager
        planTitle: "Plan y Uso Mensual",
        monthlyQueries: "Consultas del Mes (Organización)",
        used: "utilizado",
        remaining: "restantes",
        queries: "consultas",
        period: "Período",
        usersInOrg: "Usuarios",
        inOrg: "en la org.",
        planDetails: "Detalles del Plan",
        usersInOrganization: "Usuarios en la organización",
        monthlyLimit: "Límite mensual",
        queriesUsedThisMonth: "Consultas usadas este mes",
        planNote: "El contador muestra las consultas de TODOS los usuarios de la organización. Se reinicia automáticamente el primer día de cada mes.",
        orgExceededLimit: "La organización ha excedido el límite mensual",
        queriesLeft: "consultas para la organización",
        loadingPlan: "Cargando información del plan...",
        noUsageData: "No hay datos de uso disponibles",
        retry: "Reintentar",

        // File manager
        fileManagerTitle: "Gestor de Archivos",
        filesCount: "archivos",
        total: "total",
        searchFiles: "Buscar archivos...",
        uploadFile: "Subir Archivo",
        fileName: "Nombre del Archivo",
        fileType: "Tipo",
        size: "Tamaño",
        uploadedBy: "Subido Por",
        uploadDate: "Fecha de Carga",
        download: "Descargar",
        delete: "Eliminar",
        noPermission: "No tienes permisos para ver archivos",
        errorLoadingFiles: "Error al cargar archivos",
        fileTypeNotAllowed: "Tipo de archivo no permitido. Usa CSV, Excel, PDF o imágenes.",
        fileSizeExceeded: "El archivo excede el límite de 500 MB por archivo",
        uploading: "Subiendo...",
        fileUploadedSuccess: "Archivo subido correctamente",
        errorUploadingFile: "Error al subir archivo",
        connectionError: "Error de conexión al subir archivo",
        errorDownloading: "Error al generar enlace de descarga",
        errorDeleting: "Error al eliminar archivo",
        fileDeletedSuccess: "Archivo eliminado correctamente",
        dragDropHint: "Arrastra archivos aquí o haz clic para seleccionar",
        fileTypesHint: "CSV, Excel, PDF, Imágenes (máx 500MB por archivo)",
        loadingFiles: "Cargando archivos...",
        noFilesUploaded: "No hay archivos subidos",
        uploadFirstFile: "Sube tu primer archivo usando el área de arriba",
        file: "Archivo",
        type: "Tipo",
        uploaded: "Subido",
        confirmDelete: "Confirmar eliminación",
        confirmDeleteMessage: "¿Estás seguro de que deseas eliminar",
        cancel: "Cancelar"
    },

    // Interactive Guide
    guide: {
        // Plataforma nueva (src/nueva)
        noRolesConfigured: "No hay roles configurados para esta guía.",
        noPhasesConfigured: "No hay fases configuradas para esta guía.",
        title: "Guía Interactiva de Análisis",
        subtitle: "Explora los datos de pricing y elasticidad con consultas guiadas por rol o fase de análisis",
        byRole: "Por Rol",
        byPhase: "Por Fase",
        progress: "Progreso",
        completed: "completado",
        priority: "Prioridad",
        high: "Alta",
        medium: "Media",
        low: "Baja",
        estimatedTime: "Tiempo est.",
        minutes: "min",
        runQuery: "Ejecutar",
        running: "Ejecutando...",
        viewFullData: "Ver datos completos",
        loadingData: "Cargando datos...",
        processingQuery: "Procesando consulta...",
        close: "Cerrar",
        queriesCount: "consultas",

        // Roles
        roles: {
            ceo: "CEO",
            ceoDesc: "Visión estratégica global de pricing y su impacto en la rentabilidad",
            cfo: "CFO",
            cfoDesc: "Impacto financiero de las estrategias de pricing",
            commercial: "Director Comercial",
            commercialDesc: "Oportunidades de crecimiento y estrategias de venta",
            revenue: "Director de Revenue Management",
            revenueDesc: "Optimización de ingresos y gestión de precios dinámicos",
            marketing: "Director de Marketing",
            marketingDesc: "Efectividad de campañas y estrategias de posicionamiento",
            ecommerce: "Gerente de eCommerce",
            ecommerceDesc: "Performance de canal online y pricing digital",
            priceAnalyst: "Analista de Precios",
            priceAnalystDesc: "Análisis detallado de precios y posicionamiento competitivo",
            elasticityAnalyst: "Analista de Elasticidad",
            elasticityAnalystDesc: "Sensibilidad de precios y análisis de elasticidad de demanda"
        },

        // Phases
        phases: {
            exploration: "Exploración de Datos",
            explorationDesc: "Entender la estructura y distribución de los datos",
            descriptive: "Análisis Descriptivo Pricing",
            descriptiveDesc: "Estadísticas y métricas del pricing actual",
            advanced: "Analítica Avanzada",
            advancedDesc: "Análisis predictivo y modelado",
            geographic: "Análisis Geográfico",
            geographicDesc: "Distribución regional y estrategias de pricing local",
            optimization: "Optimización de Precios",
            optimizationDesc: "Recomendaciones y simulación de escenarios",
            export: "Exportación",
            exportDesc: "Generar reportes y exportaciones"
        }
    },

    // Reports
    reports: {
        // Plataforma nueva (src/nueva): «exportPdf» dice «Export PDF» también en es; ésta es la traducida.
        exportPdfButton: "Exportar PDF",
        title: "Reportes y Análisis",
        loading: "Cargando reporte...",
        noReports: "No hay reportes disponibles",
        selectReport: "Selecciona un reporte para visualizar",
        lastUpdate: "Última actualización",
        fullscreen: "Pantalla completa",
        refresh: "Actualizar",
        myFilters: "Mis Filtros",
        savedFilters: "Filtros Guardados",
        saveCurrentFilters: "Guardar Filtros Actuales",
        filterName: "Nombre del filtro",
        filterNamePlaceholder: "Ej: 'Q1 2024 - Región Norte'",
        filterDescription: "Descripción (opcional)",
        saving: "Guardando...",
        apply: "Aplicar",
        deleteFilter: "Eliminar filtro",
        noFilters: "No tienes filtros guardados aún.",
        noFiltersHint: "Ajusta los filtros del reporte y guárdalos arriba.",
        filterSaved: "Filtros guardados exitosamente",
        filterApplied: "Filtros aplicados",
        filterDeleted: "Filtro eliminado",
        filterError: "Error al guardar filtros",
        enterFilterName: "Ingresa un nombre para el filtro",
        resetFilters: "Resetear Filtros",
        exportPdf: "Export PDF",
        default: "Por defecto",
        savedOn: "Guardado"
    },

    // Common
    common: {
        loading: "Cargando...",
        error: "Error",
        success: "Éxito",
        confirm: "Confirmar",
        cancel: "Cancelar",
        save: "Guardar",
        saving: "Guardando...",
        delete: "Eliminar",
        edit: "Editar",
        add: "Agregar",
        search: "Buscar",
        filter: "Filtrar",
        clear: "Limpiar",
        close: "Cerrar",
        back: "Atrás",
        next: "Siguiente",
        yes: "Sí",
        no: "No",
        ok: "OK",
        noData: "No hay datos disponibles",
        required: "Requerido",
        optional: "Opcional"
    },

    // User Profile
    profile: {
        title: "Perfil de Usuario",
        email: "Correo electrónico",
        organization: "Organización",
        role: "Rol",
        plan: "Plan",
        features: "Funcionalidades",
        logout: "Cerrar Sesión",
        settings: "Configuración"
    },

    // Floating Chat
    floatingChat: {
        // Plataforma nueva (src/nueva)
        greetingTitle: "Hola, soy tu Asistente IA",
        greetingText: "Pregúntame por precios, promociones o escenarios. Yo te doy alternativas; la decisión es tuya.",
        suggestions: "Consultas sugeridas",
        moreSuggestions: "Más sugerencias",
        lessSuggestions: "Menos sugerencias",
        levelBasic: "Básica",
        levelMedium: "Media",
        levelAdvanced: "Avanzada",
        online: "En línea",
        openInChat: "Abrir en AI Pricing Engine",
        close: "Cerrar Asistente IA",
        title: "Asistente IA",
        welcome: "¡Hola! Soy tu **Motor de Análisis de Precios con IA**. Puedo ayudarte a consultar información del datalake, analizar precios de competencia y generar insights.\n\n**Funciones disponibles:**\n- Análisis de datos\n- Análisis de imágenes (gráficos, tablas, etc.)\n- Procesamiento de archivos Excel\n- Análisis de documentos PDF\n\n¿Qué te gustaría saber?",
        cleared: "Chat limpiado. Soy tu **Motor de Análisis de Precios con IA**. ¿En qué puedo ayudarte?",
        save: "Guardar conversación",
        expand: "Expandir",
        restore: "Restaurar tamaño",
        clear: "Limpiar chat",
        minimize: "Minimizar",
        attach: "Adjuntar archivo",
        screenshot: "Capturar pantalla",
        analyzing: "Analizando...",
        // Screenshot guide
        screenshotGuideTitle: "Captura de Pantalla",
        screenshotGuideText: "Aparecerá un diálogo del navegador para seleccionar qué deseas compartir.",
        screenshotStep1: "Selecciona \"Esta pestaña\" en el diálogo",
        screenshotStep2: "Haz clic en \"Compartir\" para capturar",
        screenshotStep3: "Agrega tu pregunta y envía",
        cancel: "Cancelar",
        continueCapture: "Continuar"
    },

    // /ticket del chat del agente (src/nueva/comun/ticket): la persona le pide un cambio a Data Bunker
    ticket: {
        title: "Enviar un ticket a Data Bunker",
        description: "¿Falta un dato, necesitas un ajuste o algo no funciona? Cuéntanos y le damos seguimiento.",
        subject: "Asunto",
        subjectPlaceholder: "Ej. Agregar la cadena Soriana al tablero",
        subjectError: "Escribe un asunto de 3 a 200 caracteres.",
        details: "¿Qué necesitas?",
        detailsPlaceholder: "Cuéntanos con detalle qué necesitas…",
        detailsHint: "Incluye el módulo, la cadena o el producto; si algo falla, desde cuándo pasa.",
        detailsError: "Cuéntanos qué necesitas en al menos 10 caracteres (máximo 4,000).",
        priority: "Prioridad",
        priorityNormal: "Normal",
        priorityNormalDesc: "Lo atendemos en orden de llegada.",
        priorityUrgent: "Urgente",
        priorityUrgentDesc: "Algo dejó de funcionar o te impide trabajar.",
        attach: "Adjuntar esta conversación",
        attachDesc: "Incluye tus últimos {count} mensajes para darnos contexto.",
        attachNone: "Esta conversación todavía no tiene mensajes.",
        send: "Enviar a Data Bunker",
        sending: "Enviando…",
        cancel: "Cancelar",
        another: "Enviar otro ticket",
        done: "Listo",
        successTitle: "Ticket #{id} enviado.",
        successText: "Data Bunker ya lo recibió; aquí verás su avance.",
        limitError: "Ya enviaste 10 tickets hoy. Podrás enviar más mañana; si es urgente, escríbele a tu contacto de Data Bunker.",
        unavailable: "Los tickets todavía no están disponibles. Intenta más tarde.",
        networkError: "No pudimos conectar con Data Bunker. Revisa tu conexión e intenta de nuevo.",
        sendError: "No pudimos enviar tu ticket. Intenta de nuevo en un momento.",
        recent: "Tus tickets recientes",
        refresh: "Actualizar tickets",
        loading: "Cargando tus tickets…",
        loadError: "No pudimos cargar tus tickets.",
        retry: "Reintentar",
        empty: "Aún no has enviado tickets.",
        showAll: "Ver los {count}",
        showLess: "Ver menos",
        status: {
            nuevo: "Nuevo",
            recibido: "Recibido",
            en_curso: "En curso",
            resuelto: "Resuelto",
            descartado: "Descartado"
        }
    },

    // Errors
    errors: {
        generic: "Ocurrió un error. Por favor intenta de nuevo.",
        network: "Error de red. Verifica tu conexión.",
        unauthorized: "No autorizado. Por favor inicia sesión de nuevo.",
        notFound: "Recurso no encontrado.",
        serverError: "Error del servidor. Por favor intenta más tarde."
    },

    // Terms and Conditions
    tyc: {
        title: "Términos y Condiciones",
        sections: [
            {
                title: "1. Introducción",
                content: "Estos Términos y Condiciones rigen el uso del AI Pricing Analytics Assistant. Al utilizar este servicio, aceptas cumplir con todas las condiciones aquí descritas. Ten en cuenta que los precios sugeridos son solo una guía y deberán ser validados por el usuario final."
            },
            {
                title: "2. Uso del Servicio",
                content: "El asistente proporciona recomendaciones basadas en datos. Aunque se esfuerza por ser preciso, no garantizamos la exactitud absoluta de los resultados. Los precios sugeridos deben ser considerados como una guía y es responsabilidad del usuario final validarlos antes de su implementación."
            },
            {
                title: "3. Privacidad y Seguridad",
                content: "La privacidad y seguridad de tus datos se heredan de los SLA, reglas y políticas de seguridad de AWS y los servicios utilizados en la arquitectura del agente, como S3, Lambda, PostgreSQL y Bedrock. Además, los datos recopilados a través del asistente se utilizan exclusivamente para mejorar la precisión de las recomendaciones. No compartimos tus datos con terceros sin tu consentimiento explícito."
            },
            {
                title: "4. Limitaciones de Responsabilidad",
                content: "No seremos responsables por pérdidas o daños derivados del uso del asistente. El usuario final es responsable de validar los precios sugeridos antes de tomar decisiones comerciales."
            },
            {
                title: "5. Modificaciones",
                content: "Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones serán efectivas desde el momento de su publicación en esta página."
            },
            {
                title: "6. Contacto",
                content: "Para cualquier duda o aclaración sobre estos términos, puedes contactarnos a través de tu Asesor."
            }
        ]
    },

    // FAQ
    faq: {
        title: "Preguntas Frecuentes sobre AI Pricing Analytics Assistant",
        questions: [
            {
                question: "¿Qué es el AI Pricing Analytics Assistant?",
                answer: "Es una herramienta impulsada por inteligencia artificial que te ayuda a optimizar la estrategia de precios de tus productos, analizando ventas, márgenes, precios de la competencia y otros factores clave. Recuerda que los precios sugeridos son solo una guía y deben ser validados por el usuario final."
            },
            {
                question: "¿Qué tipo de datos se utilizan?",
                answer: "Utilizamos datos como la fecha de venta, identificadores de productos (SKU), unidades vendidas, precios finales, márgenes, y otros parámetros relacionados con la competencia y las ubicaciones geográficas."
            },
            {
                question: "¿Cómo se asegura la precisión de los precios recomendados?",
                answer: "El asistente utiliza modelos de machine learning que se entrenan constantemente con datos actualizados para ofrecer recomendaciones precisas y basadas en evidencia. Sin embargo, siempre debes validar las recomendaciones antes de implementarlas."
            },
            {
                question: "¿Cómo se protege la privacidad de mis datos?",
                answer: "La privacidad y seguridad de tus datos son nuestra prioridad. Estas se heredan de los SLA, reglas y políticas de seguridad de AWS y los servicios que utilizamos en la arquitectura del asistente, como S3, Lambda, PostgreSQL y Bedrock. Además, se manejan de acuerdo con las leyes y regulaciones vigentes, utilizando encriptación y otras medidas de seguridad avanzadas."
            },
            {
                question: "¿Puedo personalizar las recomendaciones de precios?",
                answer: "Sí, puedes ajustar los parámetros y criterios que utiliza el asistente para que las recomendaciones se adapten mejor a tus necesidades específicas. Aun así, los precios sugeridos deben ser validados antes de aplicarlos."
            }
        ]
    },

    // Guide Queries - Roles
    guideQueries: {
        roles: {
            ceo: {
                title: "CEO",
                description: "Visión estratégica global de pricing y su impacto en la rentabilidad",
                queries: [
                    { text: "Muéstrame un resumen ejecutivo con los KPIs de pricing más importantes y su impacto en la rentabilidad global", category: "resumen" },
                    { text: "¿Cuál es el impacto financiero de nuestras estrategias de pricing vs competencia?", category: "competencia" },
                    { text: "Análisis de tendencias de ventas por región y categoría en los últimos 6 meses", category: "tendencias" }
                ]
            },
            cfo: {
                title: "CFO",
                description: "Impacto financiero de las estrategias de pricing",
                queries: [
                    { text: "Impacto financiero de las estrategias de pricing optimizadas por IA", category: "financiero" },
                    { text: "Análisis de sensibilidad de precios y su efecto en el margen de contribución", category: "sensibilidad" },
                    { text: "Proyecciones financieras basadas en diferentes escenarios de pricing", category: "proyecciones" }
                ]
            },
            commercial: {
                title: "Director Comercial",
                description: "Oportunidades de crecimiento y estrategias de venta",
                queries: [
                    { text: "¿Cuáles son las principales oportunidades de crecimiento identificadas en los datos?", category: "oportunidades" },
                    { text: "Análisis de elasticidad de precios por segmento de cliente y canal de venta", category: "elasticidad" },
                    { text: "Recomendaciones de promociones cruzadas para maximizar el valor del cliente", category: "promociones" },
                    { text: "Rendimiento de ventas por canal y región con tendencias", category: "rendimiento" }
                ]
            },
            revenue: {
                title: "Director de Revenue Management",
                description: "Optimización de ingresos y gestión de precios dinámicos",
                queries: [
                    { text: "Dashboard de performance de pricing con alertas y recomendaciones", category: "dashboard" },
                    { text: "Análisis de la efectividad de las reglas de pricing implementadas", category: "efectividad" },
                    { text: "Simulación de escenarios de guerra de precios y estrategias de respuesta", category: "simulacion" }
                ]
            },
            marketing: {
                title: "Director de Marketing",
                description: "Efectividad de campañas y estrategias de posicionamiento",
                queries: [
                    { text: "Análisis de la efectividad de campañas de marketing en relación con las estrategias de pricing", category: "campañas" },
                    { text: "Recomendaciones de precios para nuevos lanzamientos de productos", category: "lanzamientos" },
                    { text: "Segmentación de clientes basada en sensibilidad al precio y comportamiento de compra", category: "segmentacion" }
                ]
            },
            ecommerce: {
                title: "Gerente de eCommerce",
                description: "Optimización del canal digital",
                queries: [
                    { text: "Optimización de precios en tiempo real para el canal online", category: "online" },
                    { text: "Análisis de comportamiento de compra en relación con los precios", category: "comportamiento" },
                    { text: "Estrategias de pricing personalizadas para diferentes segmentos de clientes online", category: "personalizacion" }
                ]
            },
            priceAnalyst: {
                title: "Analista de Precios",
                description: "Análisis detallado y modelado de precios",
                queries: [
                    { text: "Herramientas de modelado predictivo para análisis de escenarios de precios", category: "modelado" },
                    { text: "Reportes detallados de elasticidad de precios por SKU y categoría", category: "elasticidad" },
                    { text: "Alertas automáticas de anomalías en precios o comportamiento de compra", category: "anomalias" },
                    { text: "Dame una tabla con los top 20 productos por margen de contribución", category: "top_productos" }
                ]
            },
            categories: {
                title: "Director de Categorías",
                description: "Gestión de portfolio y optimización de categorías",
                queries: [
                    { text: "Análisis de contribución al margen por producto, categoría y cliente", category: "contribucion" },
                    { text: "Optimización de la estructura de descuentos y promociones", category: "descuentos" },
                    { text: "Identificación de oportunidades de mejora en la rentabilidad por categoría", category: "rentabilidad" }
                ]
            }
        },
        phases: {
            eda: {
                title: "Exploración de Datos (EDA)",
                description: "Análisis exploratorio inicial de los datos disponibles",
                queries: [
                    { text: "Dame una tabla con las principales tendencias de ventas por categoría", category: "tendencias" },
                    { text: "¿Cuáles son las columnas y métricas disponibles en los datos?", category: "estructura" },
                    { text: "Resumen estadístico de los datos de precios y ventas", category: "estadisticas" },
                    { text: "¿Qué período de tiempo cubren los datos disponibles?", category: "periodo" }
                ]
            },
            pricing: {
                title: "Análisis Descriptivo Pricing",
                description: "Análisis detallado de estrategias de precios actuales",
                queries: [
                    { text: "Distribución de precios por categoría y competidor", category: "distribucion" },
                    { text: "Análisis de gaps de precio vs competencia por categoría", category: "gaps" },
                    { text: "Evolución histórica de precios por producto y marca", category: "evolucion" },
                    { text: "Comparativa de márgenes por canal de venta", category: "margenes" }
                ]
            },
            elasticity: {
                title: "Analítica Avanzada de Elasticidad",
                description: "Análisis de sensibilidad de precios y elasticidad de demanda",
                queries: [
                    { text: "Cálculo de elasticidad precio-demanda por categoría", category: "elasticidad" },
                    { text: "Productos con mayor sensibilidad al precio", category: "sensibilidad" },
                    { text: "Impacto de cambios de precio en volumen de ventas", category: "impacto" },
                    { text: "Correlación entre precio y participación de mercado", category: "correlacion" }
                ]
            },
            geographic: {
                title: "Análisis Geográfico & Competitividad",
                description: "Análisis por región y posicionamiento competitivo",
                queries: [
                    { text: "Performance de ventas por región geográfica", category: "regional" },
                    { text: "Análisis de competitividad de precios por zona", category: "competitividad" },
                    { text: "Oportunidades de mercado por ubicación", category: "oportunidades" }
                ]
            },
            optimization: {
                title: "Optimización de Precios",
                description: "Recomendaciones de optimización basadas en análisis",
                queries: [
                    { text: "Recomendaciones de ajuste de precios para maximizar margen", category: "recomendaciones" },
                    { text: "Simulación de impacto de cambios de precio", category: "simulacion" },
                    { text: "Estrategia óptima de pricing por segmento", category: "estrategia" },
                    { text: "ROI esperado de las optimizaciones propuestas", category: "roi" }
                ]
            },
            export: {
                title: "Exportación de Recomendaciones",
                description: "Generación de reportes y exportación de datos",
                queries: [
                    { text: "Genera un reporte ejecutivo con las principales métricas", category: "reporte" },
                    { text: "Lista de productos con recomendación de cambio de precio", category: "lista" },
                    { text: "Resumen de hallazgos clave para presentación", category: "hallazgos" }
                ]
            }
        }
    },

    // MFA / TOTP setup
    mfa: {
        title: "Autenticación de dos factores (MFA)",
        loading: "Cargando configuración...",
        scanInstructions: "Escanea el código QR con tu app de autenticación (Google Authenticator, Authy, Microsoft Authenticator, 1Password, etc.).",
        cantScan: "¿No puedes escanear el QR?",
        manualSecret: "Ingresa este código manualmente en tu app de autenticación:",
        copy: "Copiar",
        copied: "Copiado",
        next: "Siguiente",
        back: "Atrás",
        cancel: "Cancelar",
        close: "Cerrar",
        retry: "Reintentar",
        enterCode: "Ingresa el código de 6 dígitos que aparece en tu app de autenticación:",
        verify: "Verificar",
        verifying: "Verificando...",
        processing: "Procesando...",
        successTitle: "¡MFA activado!",
        successDesc: "La próxima vez que inicies sesión te pediremos el código de 6 dígitos de tu app de autenticación.",
        nextLogin: "Necesitarás tu app de autenticación cada vez que inicies sesión.",
        alreadyEnabled: "MFA ya está activado en tu cuenta",
        alreadyEnabledDesc: "Estás usando una app de autenticación. Puedes reconfigurarlo (por ejemplo, al cambiar de dispositivo) o eliminarlo por completo.",
        reconfigure: "Reconfigurar MFA",
        remove: "Eliminar MFA",
        removeConfirmTitle: "¿Eliminar MFA?",
        removeConfirmDesc: "Tu cuenta dejará de tener autenticación de dos factores. Cualquier persona con tu contraseña podrá acceder. Esta acción se puede revertir activando MFA de nuevo.",
        confirmRemove: "Sí, eliminar",
        removedTitle: "MFA eliminado",
        removedDesc: "Ya no se te pedirá un código de autenticación al iniciar sesión. Te recomendamos volver a activarlo cuando puedas.",
        errorGeneric: "Ocurrió un error. Intenta de nuevo.",
        errorInvalidCode: "Código inválido. Verifica el código en tu app de autenticación e intenta de nuevo."
    },

    // Custom Reports (editor)
    report: {
        // Plataforma nueva (src/nueva)
        saveError: "No se pudo guardar",
        printPreview: "Vista de impresión · A4",
        printTitle: "Reporte para imprimir",
        printOrSave: "Imprimir / Guardar como PDF",
        close: "Cerrar",
        deleteReportTitle: "Eliminar reporte",
        untitled: "Reporte sin título",
        loading: "Cargando reporte…",
        titlePlaceholder: "Título del reporte",
        saving: "Guardando…",
        exportPdf: "PDF",
        exportPdfTitle: "Exportar a PDF (Imprimir → Guardar como PDF)",
        deleteReport: "Eliminar",
        deleteConfirm: "¿Eliminar este reporte? No se puede deshacer.",
        empty: "Este reporte está vacío.",
        emptyHint: "Agrega bloques desde la barra de abajo, o ve al chat y usa el botón \"Guardar en reporte\" en cualquier mensaje.",
        addBlockLabel: "+ Añadir bloque:",
        blockHeading: "Título",
        blockText: "Texto",
        blockDivider: "Separador",
        newHeading: "Nuevo título",
        newText: "Escribe aquí…",
        emptyPlaceholder: "*Vacío — click para editar*",
        botMessageLabel: "Respuesta del agente",
        clientMessageLabel: "Pregunta",
        moveUp: "Subir",
        moveDown: "Bajar",
        delete: "Eliminar",
        untitledHeading: "Sin título",
        markdownPlaceholder: "Escribe en markdown…",
        blockChartAlt: "Gráfica",
        chartCaptionPlaceholder: "Pie de gráfica (opcional)",
        placeholder: "Empieza a escribir, o usa los botones de arriba para insertar elementos…",
        savedJustNow: "Guardado",
        toolbar: {
            // Plataforma nueva (src/nueva)
            deleteImage: "Eliminar gráfica/imagen",
            heading: "Estilo de texto",
            paragraph: "Párrafo",
            h1: "Título 1",
            h2: "Título 2",
            h3: "Título 3",
            insertTable: "Insertar tabla",
            deleteTable: "Eliminar tabla"
        }
    }
};

export default es;
